import JumpNavigation from "./JumpNavigation.jsx";

import ReactDom from "react-dom";

export default function renderJumpNavigation() {
  const anchorsArr = Array.from(
    document.querySelectorAll(".js-jump-navigation-anchor"),
  );

  if (!anchorsArr.length) {
    return;
  }

  document.querySelectorAll(".js-jump-navigation-mount").forEach((mount, i) => {
    let index = 0;

    const links = anchorsArr.reduce((data, anchor) => {
      if (!anchor.textContent) {
        return data;
      }

      const anchorId = anchor.textContent.replace(/\s+/g, "_").toLowerCase();
      const encodedAnchorId = encodeURIComponent(anchorId);

      anchor.setAttribute("data-index", index);
      anchor.setAttribute("id", encodedAnchorId);

      data.push({
        label: anchor.textContent,
        index,
        href: `#${encodedAnchorId}`,
      });

      index++;
      return data;
    }, []);

    ReactDom.render(<JumpNavigation index={i} links={links} />, mount);
  });
}
